import { render, staticRenderFns } from "./FlowAssessments.vue?vue&type=template&id=efbdbe10&"
import script from "./FlowAssessments.vue?vue&type=script&lang=js&"
export * from "./FlowAssessments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports